module.exports = __webpack_public_path__ + "img/9.c4a78423.jpg";